import Header from './components/Header';
import Hero from './components/Hero';
import IndexSection from './components/IndexSection';
import CarouselSection from './components/CarouselSection';
import FaqSection from './components/FaqSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import ContactSection from './components/ContactSection';
import FeaturesSection from './components/FeaturesSection';
import CardsSection from './components/CardsSection';
import UpdatesSection from './components/UpdatesSection';
import AboutSection from './components/AboutSection';
import AppSection from './components/AppSection';
import CommentsSection from './components/CommentsSection';
import RankingSection from './components/RankingSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <IndexSection />
        <CarouselSection />
        <FaqSection />
        <TopicsSection />
        <MediaSection />
        <ContactSection />
        <FeaturesSection />
        <CardsSection />
        <UpdatesSection />
        <AboutSection />
        <AppSection />
        <CommentsSection />
        <RankingSection />
      </main>
      <Footer />
    </>
  );
}